import { ref, computed, reactive, defineComponent, toRefs, onMounted } from "vue";
import { saveAs } from "file-saver";
export default defineComponent({
  isGlobal: true,
  name: "DownloadFile",
  props: {
    fileName: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
  },
  emits: ["download"],
  setup(props, { emit }) {
    const downloadFile = () => {
      saveAs(props.url, props.fileName);
      emit("download");
    };
    return {
      downloadFile,
    };
  },
});
